module.exports = __webpack_public_path__ + "img/y- (6).fa68c49e.png";